import { useSelector } from "react-redux";
import Footer from "./Footer";
import GptMovieSuggestions from "./GptMovieSuggestions";
import GptSearchBar from "./GptSearchBar";
import { AI_SEARCH_BG_IMG } from "../utils/constants";
import ResultComp from "./ResultComp";
const GptSearchPage = () => {
  const trendingMovies = useSelector((store) => store.movies.trendingMovies);
  const { tmdbMovieList } = useSelector((store) => store.gpt);

  return (
    <div>
      <div className="fixed -z-10 inset-0 flex items-center justify-center">
        <img
          src={AI_SEARCH_BG_IMG}
          alt="Background Canvas"
          className="absolute inset-0 w-full h-full object-cover opacity-50"
        />
      </div>
      <div className="px-[1%] pt-[30%] lg:pt-[8%] md:pt-[18%]">
        <GptSearchBar />

        {tmdbMovieList ? (
          <GptMovieSuggestions />
        ) : (
          <div className="py-1 mt-1 bg-[#0e0d26] bg-opacity-80 rounded-lg">
            <ResultComp movieList={trendingMovies} title="Trending Today" />
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default GptSearchPage;
